import { useAuthStore } from '../store/authStore'
import type { Rol } from '../types'

/**
 * Hook de conveniencia para consumir el estado de auth en componentes.
 * No añade estado propio — delega al authStore de Zustand.
 */
export function useAuth() {
  const store = useAuthStore()
  return {
    user:            store.user,
    /** Access token actual (puede estar expirado; el interceptor lo refresca automáticamente). */
    token:           store.accessToken,
    login:           store.login,
    logout:          store.logout,
    isAuthenticated: store.isAuthenticated(),
    isConformity:    store.isConformity(),
    canWrite:        store.canWrite(),
    rol:             store.user?.rol as Rol | undefined,
  }
}
